import useProjects from './useProjects'

export default function useIsPayingKEIAccount(accountId: string) {
  const { projects, loading: projectsLoading } = useProjects(accountId as string)
  return {
    isPayingAccount: projects?.some((project) => project.is_kei === true && project.planId !== '1'),
    projectsLoading: projectsLoading,
  }
}
